import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-393" data-mp="1wbcztzrohphz">
    <App data-id="element-394" data-mp="1wcxurqhwnagd" />
  </BrowserRouter>, document.getElementById('root'));